module.exports = __webpack_public_path__ + "img/e2.86bd184a.jpg";